import { serverAdapter } from '../@worker';

// Cloudflare Workers export
export default {
    fetch: serverAdapter.fetch,
    // Optional: Add scheduled, queue, email handlers here if needed
    // scheduled(event, env, ctx) { },
    // queue(batch, env, ctx) { },
};


